
export class Street {
	constructor(
		public streetID: number,

        public streetName: string

	) { 
	}

}


// WEBPACK FOOTER //
// ./src/app/street.ts